import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { decaturILConfig } from "./data";

export default function DecaturILPage() {
  return <CityPageTemplate config={decaturILConfig} />;
}